<div class="legend-container">
    <div class="chart-legend">
        <ng-container *ngFor="let item of legendBar?.itemLabel; let index = index;">
            <div class="legend-item" >
                <div class="color-indicator" [ngStyle]="{'background-color': getFrameColor(index)}"></div>
                <label class="dds-custom-control dds-custom-control_green title" (click)="itemClick(index)">{{item}}</label>
            </div>
        </ng-container>
    </div>
</div>